import React from 'react';

import Row from 'react-bootstrap/Row';

import {
  Save,
  Submit,
  Approve,
  Reject,
  CreateOrder,
  PendCAR,
  Close,
  Cancel,
  CreateReturn,
  CARComplete,
  Back
} from 'components/form/buttons';

const SubmitButtons = () => (
  <>
    <Row className={'mb-2 text-center'}>
      <Back />
      <Save />
      <Submit />
      <Approve />
      <Reject />
      <CreateOrder />
      <CreateReturn />
      <PendCAR />
      <CARComplete />
      <Close />
      <Cancel />
    </Row>
  </>
)

export { SubmitButtons };
